import React from 'react';
import LocationTemplate from './LocationTemplate';

const CreedmoorPage: React.FC = () => {
  return (
    <LocationTemplate
      cityName="Creedmoor"
      stateName="North Carolina"
      countyName="Granville"
      zipCodes={["27522"]}
      latitude={36.1257}
      longitude={-78.6781}
      population={4427}
      historicalFact="Named after Richard Creed and Thomas Moore, early landowners who donated land for the railroad."
      nearbyTowns={[
        "Oxford, NC",
        "Durham, NC",
        "Wake Forest, NC",
        "Butner, NC",
        "Stem, NC",
        "Franklinton, NC",
        "Henderson, NC",
        "Raleigh, NC"
      ]}
    />
  );
};

export default CreedmoorPage;